module.exports = __webpack_public_path__ + "static/media/connect_3.6af4ec27.jpg";